var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewsWithSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5384 5.54154H8.30762V4.6123H17.5384V5.54154Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30762 7.38135H17.5384V8.31058H8.30762V7.38135Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5384 11.0796H8.30762V10.1504H17.5384V11.0796Z",
    fill: "#B41730"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.923 13.8492H8.30762V12.9199H12.923V13.8492Z",
    fill: "#B41730"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53508 1.84277H20.3105V17.9997C20.3105 19.2775 19.2775 20.3105 17.9997 20.3105H4.15354C2.87579 20.3105 1.84277 19.2775 1.84277 17.9997V4.612H5.53508V1.84277ZM6.46431 2.772V5.54123H2.772V17.9997C2.772 18.7643 3.38899 19.3812 4.15354 19.3812H17.9997C18.7643 19.3812 19.3812 18.7643 19.3812 17.9997V2.772H6.46431Z",
    fill: "#B41730"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46409 5.07666V17.9997C6.46409 19.2775 5.43107 20.3105 4.15332 20.3105V19.3813C4.91787 19.3813 5.53486 18.7643 5.53486 17.9997V5.07666H6.46409Z",
    fill: "#B41730"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_14255)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6133 13.2461C13.6133 11.206 15.2671 9.55225 17.3071 9.55225C19.3472 9.55225 21.001 11.206 21.001 13.2461C21.001 15.2861 19.3472 16.9399 17.3071 16.9399C15.2671 16.9399 13.6133 15.2861 13.6133 13.2461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3369 13.2462C13.3369 11.0532 15.1147 9.27539 17.3077 9.27539C19.5007 9.27539 21.2785 11.0532 21.2785 13.2462C21.2785 14.0699 21.0276 14.8351 20.5981 15.4695L23.749 18.6204L23.0512 19.3181L19.9464 16.2134C19.245 16.8376 18.3206 17.2169 17.3077 17.2169C15.1147 17.2169 13.3369 15.4392 13.3369 13.2462ZM17.3077 10.2939C15.6772 10.2939 14.3554 11.6156 14.3554 13.2462C14.3554 14.8767 15.6772 16.1985 17.3077 16.1985C18.9382 16.1985 20.26 14.8767 20.26 13.2462C20.26 11.6156 18.9382 10.2939 17.3077 10.2939Z",
    fill: "#B41730"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9466 16.213C19.2451 16.8373 18.3207 17.2166 17.3078 17.2166C15.1148 17.2166 13.337 15.4388 13.337 13.2458C13.337 11.0528 15.1148 9.27504 17.3078 9.27504C19.5008 9.27504 21.2786 11.0528 21.2786 13.2458C21.2786 14.0696 21.0277 14.8348 20.5982 15.4691L23.7491 18.62L23.0513 19.3178L19.9466 16.213ZM21.2963 15.3839C21.6384 14.7469 21.8324 14.0184 21.8324 13.2458C21.8324 10.7469 19.8067 8.72119 17.3078 8.72119C14.8089 8.72119 12.7832 10.7469 12.7832 13.2458C12.7832 15.7447 14.8089 17.7704 17.3078 17.7704C18.2729 17.7704 19.1683 17.4677 19.9029 16.9526L23.0513 20.101L24.5324 18.62L21.2963 15.3839ZM17.3078 10.8473C15.9832 10.8473 14.9094 11.9212 14.9094 13.2458C14.9094 14.5704 15.9832 15.6443 17.3078 15.6443C18.6325 15.6443 19.7063 14.5704 19.7063 13.2458C19.7063 11.9212 18.6325 10.8473 17.3078 10.8473ZM14.3555 13.2458C14.3555 11.6153 15.6773 10.2935 17.3078 10.2935C18.9383 10.2935 20.2601 11.6153 20.2601 13.2458C20.2601 14.8763 18.9383 16.1981 17.3078 16.1981C15.6773 16.1981 14.3555 14.8763 14.3555 13.2458Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_14255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 11.0769,
    fill: "white",
    transform: "translate(12.9229 8.86133)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewsWithSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news_with_search.1cda0d6361e4815af324e8c2293e8472.svg";